import _ from 'lodash';

export const SLIDE_TYPES = {
    DEFAULT: {messageId: 'types.slide.default'},
    IMAGE: {messageId: 'types.slide.image'}
};

export const SLIDE_TYPE_OPTIONS = Object.keys(SLIDE_TYPES).map(key => _.set(SLIDE_TYPES[key], 'key', key));


// WEBPACK FOOTER //
// ./src/constants/slideTypes.js